import pick from 'lodash/pick'
import cloneDeep from 'lodash/cloneDeep'
import {
  isEmptyString,
  isNumber,
  isEmptyObject,
  isNumberString
} from 'lib/detectType'

const getTextParams = formData => {
  const { couponCollapsed, buttonsCollapsed } = formData
  const params = pick(formData, ['content', 'buttons', 'coupon'])
  if (buttonsCollapsed === true) {
    delete params.buttons
  }
  if (couponCollapsed === true) {
    delete params.coupon
  }
  return params
}

const getImageParams = formData => {
  const { couponCollapsed, buttonsCollapsed } = formData
  const params = pick(formData, [
    'fileData',
    'fileValidationResult',
    'content',
    'buttons',
    'coupon',
    'imageLink'
  ])
  if (isEmptyString(params?.content)) {
    delete params.content
  }
  if (buttonsCollapsed === true || params?.buttons?.length === 0) {
    delete params.buttons
  }
  if (couponCollapsed === true) {
    delete params.coupon
  }
  if (isEmptyString(params?.imageLink)) {
    delete params.imageLink
  }
  return params
}

const getWideItemListParams = formData => {
  const { slideIndex, slideList = [] } = formData
  slideList[slideIndex] = pick(formData, [
    'header',
    'buttons',
    'coupon',
    'title',
    'fileData',
    'fileValidationResult',
    'linkMobile',
    'linkPc',
    'linkAndroid',
    'linkIos'
  ])
  const { couponCollapsed, buttonsCollapsed } = slideList?.[0] || {}
  const params = pick(slideList[0], ['header', 'buttons', 'coupon'])
  const mainWideItem = pick(slideList[0], [
    'title',
    'fileData',
    'fileValidationResult',
    'linkMobile',
    'linkPc',
    'linkAndroid',
    'linkIos'
  ])
  params.mainWideItem = mainWideItem
  const subWideItemList = slideList.slice(1).map(item => {
    return pick(item, [
      'title',
      'fileData',
      'fileValidationResult',
      'linkMobile',
      'linkPc',
      'linkAndroid',
      'linkIos'
    ])
  })
  params.subWideItemList = subWideItemList
  if (buttonsCollapsed === true) {
    delete params.buttons
  }
  if (couponCollapsed === true) {
    delete params.coupon
  }
  return params
}

const formatCommercePrice = (commerce = {}) => {
  if (
    isEmptyString(commerce?.regularPrice) ||
    (commerce.regularPrice !== '#{정상가격}' &&
      !isNumberString(commerce.regularPrice))
  ) {
    delete commerce.regularPrice
  }
  if (
    isEmptyString(commerce?.discountPrice) ||
    (commerce.discountPrice !== '#{할인가격}' &&
      !isNumberString(commerce.discountPrice))
  ) {
    delete commerce.discountPrice
  }
  if (
    isEmptyString(commerce?.discountRate) ||
    (commerce.discountRate !== '#{할인율}' &&
      !isNumberString(commerce.discountRate))
  ) {
    delete commerce.discountRate
  }
  if (
    isEmptyString(commerce?.discountFixed) ||
    (commerce.discountFixed !== '#{정액할인가격}' &&
      !isNumberString(commerce.discountFixed))
  ) {
    delete commerce.discountFixed
  }
  if (
    (isNumber(commerce.regularPrice) ||
      isNumberString(commerce.regularPrice)) &&
    (isNumber(commerce.discountPrice) ||
      isNumberString(commerce.discountPrice)) &&
    commerce.regularPrice === commerce.discountPrice
  ) {
    delete commerce.discountPrice
  }
  if (
    commerce?.regularPrice === undefined &&
    commerce?.discountPrice === undefined &&
    commerce?.discountRate === undefined &&
    commerce?.discountFixed === undefined
  ) {
    commerce.regularPrice = 0
  }
  return commerce
}

const getCommerceParams = formData => {
  const { contentCollapsed, couponCollapsed, buttonsCollapsed } = formData
  const params = pick(formData, [
    'additionalContent',
    'fileData',
    'fileValidationResult',
    'imageLink',
    'buttons',
    'coupon',
    'commerce'
  ])
  params.commerce = formatCommercePrice(params.commerce)
  if (buttonsCollapsed === true) {
    delete params.buttons
  }
  if (couponCollapsed === true || isEmptyObject(params.coupon)) {
    delete params.coupon
  }
  if (contentCollapsed === true) {
    delete params.additionalContent
  }
  return params
}

const getCarouselFeedParams = formData => {
  const { slideIndex, slideList = [], tail } = formData
  slideList[slideIndex] = pick(formData, [
    'header',
    'content',
    'fileData',
    'fileValidationResult',
    'buttons',
    'commerce',
    'coupon',
    'linkMobile',
    'linkPc',
    'linkAndroid',
    'linkIos'
  ])
  const { moreButtonCollapsed } = slideList?.[0] || {}
  const params = {}
  const list = slideList.map(item => {
    const { couponCollapsed, buttonsCollapsed } = item
    const result = pick(item, [
      'header',
      'content',
      'fileData',
      'fileValidationResult',
      'imageLink',
      'coupon',
      'buttons'
    ])
    if (buttonsCollapsed === true) {
      delete result.buttons
    }
    if (couponCollapsed === true) {
      delete result.coupon
    }
    return result
  })
  const carousel = { list, tail }
  params.carousel = carousel
  if (moreButtonCollapsed === true) {
    delete params.carousel.tail
  }
  return params
}

const getCarouselCommerceParams = formData => {
  const { slideIndex, slideList = [], tail } = formData
  slideList[slideIndex] = pick(formData, [
    'header',
    'content',
    'additionalContent',
    'fileData',
    'widthRatio',
    'fileValidationResult',
    'buttons',
    'commerce',
    'coupon',
    'linkMobile',
    'linkPc',
    'linkAndroid',
    'linkIos'
  ])
  const { moreButtonCollapsed } = slideList?.[0] || {}
  const params = {}
  const head = pick(slideList[0], [
    'header',
    'content',
    'fileData',
    'widthRatio',
    'fileValidationResult',
    'linkMobile',
    'linkPc',
    'linkAndroid',
    'linkIos'
  ])
  const list = slideList.slice(1).map(item => {
    const { couponCollapsed, buttonsCollapsed } = item
    const result = pick(item, [
      'additionalContent',
      'fileData',
      'fileValidationResult',
      'imageLink',
      'commerce',
      'coupon',
      'buttons'
    ])
    result.commerce = formatCommercePrice(result.commerce)
    if (buttonsCollapsed === true) {
      delete result.buttons
    }
    if (couponCollapsed === true) {
      delete result.coupon
    }
    return result
  })
  const carousel = {
    head,
    list,
    tail
  }
  params.carousel = carousel
  if (moreButtonCollapsed === true) {
    delete params.carousel.tail
  }
  return params
}

const getCommonParams = formData => {
  const { channelType } = formData
  const params = pick(formData, ['chatBubbleType', 'adult'])
  params.name = formData?.templateName
  if (channelType === 'CHANNEL_GROUP') {
    params.pfGroupId = formData?.pfGroupId
  } else {
    params.pfId = formData?.pfId
  }
  return params
}

export function bmsTplFormDataToParams(data) {
  const formData = cloneDeep(data)
  const { chatBubbleType } = formData
  let params = {}
  if (chatBubbleType === 'TEXT') {
    params = getTextParams(formData)
  }
  if (chatBubbleType === 'IMAGE' || chatBubbleType === 'WIDE') {
    params = getImageParams(formData)
  }
  if (chatBubbleType === 'WIDE_ITEM_LIST') {
    params = getWideItemListParams(formData)
  }
  if (chatBubbleType === 'COMMERCE') {
    params = getCommerceParams(formData)
  }
  if (chatBubbleType === 'CAROUSEL_FEED') {
    params = getCarouselFeedParams(formData)
  }
  if (chatBubbleType === 'CAROUSEL_COMMERCE') {
    params = getCarouselCommerceParams(formData)
  }
  Object.assign(params, getCommonParams(formData))
  return params
}

export default bmsTplFormDataToParams
